import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { isStaffLoggedIn, hasRole } from "./auth";
import Team from "./pages/Team";
import Discounts from "./pages/Discounts";
import Orders from "./pages/Orders";
import DeliveryZones from "./pages/DeliveryZones";
import SiteImages from "./pages/SiteImages";
import Categories from "./pages/Categories";
import Community from "./pages/Community";
import Home from "./pages/Home";
import HeaderComponent from "./components/Home/Header/Header";
import NewArriavals from "./pages/NewArriavals";
import ProductDetail from "./pages/ProductDetail";
import Admin from "./pages/Admin";
import AdminDashboard from "./pages/AdminDashboard";
import { CartProvider } from "./components/Cart/cartContext";
import Cart from "./pages/Cart";
// import Welcome from "./pages/Welcome";
import GetAllItem from "./pages/GetAllItem";
import UpCycled from "./pages/UpCycled";
import Collections from "./pages/Collections";
import Shop from "./pages/Shop";
import About from "./pages/About";
import EventPopup from "./components/EventPopup/EventPopup";

// Backoffice pages need a valid staff token; `roles` narrows access further
const RequireRole = ({ roles, children }) => {
  const allowed = roles ? hasRole(...roles) : isStaffLoggedIn();
  return allowed ? children : <Navigate to="/paulvictor" replace />;
};

function App() {
  const cartItemCount = 0;
  const location = useLocation(); // Get the current location
  const path = location.pathname;

  // Admin screens have no storefront chrome
  const adminPaths = ["/paulvictor", "/admin-dashboard", "/all-item", "/admin-team", "/admin-discounts", "/admin-orders", "/admin-delivery", "/admin-images", "/admin-categories", "/admin-community"];
  // These pages render their own overlay header inside a full-bleed banner
  const selfHeaderPaths = ["/new-arrivals", "/upcycle"];

  const hideHeader =
    adminPaths.includes(path) || selfHeaderPaths.includes(path);
  // Transparent over the hero on the homepage, solid everywhere else
  const headerVariant = path === "/" ? "overlay" : "solid";

  return (
    <CartProvider>
      <div className="fullPageContainer">
        {!hideHeader && (
          <HeaderComponent cartCount={cartItemCount} variant={headerVariant} />
        )}
        {!adminPaths.includes(path) && <EventPopup />}
        <Routes>
          {/* <Route path="/" element={<Welcome />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/new-arrivals" element={<NewArriavals />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/about" element={<About />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/upcycle" element={<UpCycled />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/paulvictor" element={<Admin />} />
          <Route
            path="/admin-dashboard"
            element={
              <RequireRole roles={["admin", "manager"]}>
                <AdminDashboard />
              </RequireRole>
            }
          />
          <Route path="/cart" element={<Cart />} />
          <Route
            path="/all-item"
            element={
              <RequireRole>
                <GetAllItem />
              </RequireRole>
            }
          />
          <Route
            path="/admin-team"
            element={
              <RequireRole roles={["admin"]}>
                <Team />
              </RequireRole>
            }
          />
          <Route
            path="/admin-discounts"
            element={
              <RequireRole>
                <Discounts />
              </RequireRole>
            }
          />
          <Route
            path="/admin-orders"
            element={
              <RequireRole>
                <Orders />
              </RequireRole>
            }
          />
          <Route
            path="/admin-delivery"
            element={
              <RequireRole>
                <DeliveryZones />
              </RequireRole>
            }
          />
          <Route
            path="/admin-images"
            element={
              <RequireRole>
                <SiteImages />
              </RequireRole>
            }
          />
          <Route
            path="/admin-categories"
            element={
              <RequireRole>
                <Categories />
              </RequireRole>
            }
          />
          <Route
            path="/admin-community"
            element={
              <RequireRole>
                <Community />
              </RequireRole>
            }
          />
        </Routes>
      </div>
    </CartProvider>
  );
}

export default App;
